<script>
  import Multiselect from 'vue-multiselect'
  import { addressTypesComputed, addressTypesMethods, countriesComputed, countriesMethods } from '@state/helpers'
  import { getStringFromObjectAddress } from '@utils/format-address';

  export default {
    components: {
      Multiselect,
    },
    props: {
      id: {
        type: String,
        required: true
      },
      disabled: {
        type: Boolean,
        required: false
      },
      label: {
        type: String,
        default: ''
      },
      value: {
        type: String,
        default: ''
      },
      address: {
        type: Object,
        default: () => ({
          line_1: null,
          suburb: null,
          state: null,
          postcode: null,
          country_id: null,
        })
      },
      valueType: {
        type: String,
        default: 'object'
      },
      collapsed: {
        type: Boolean,
        default: false
      },
      inlineValidation: {
        type: Boolean,
        default: false
      },
      validation: {
        type: [String, Object],
        default: null
      },
      selfHandleAddress: {
        type: Boolean,
        default: false
      },
      showAddressType: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        isShowManualForm: false,
        addressTypes: [],
        innited: {
          address: false,
        },
        showingAddress: ''
      }
    },
    computed: {
      ...countriesComputed,
      ...addressTypesComputed,
      inValidation: function () {
        return this.validation;
      },
      addressValidation: function () {
        return this.valueType === 'string' ? this.inValidation : this.inValidation && this.inValidation.line_1;
      },
      suburbValidation: function () {
        return this.valueType === 'string' ? this.inValidation : this.inValidation && this.inValidation.suburb;
      },
      stateValidation: function () {
        return this.valueType === 'string' ? this.inValidation : this.inValidation && this.inValidation.state;
      },
      postcodeValidation: function () {
        return this.valueType === 'string' ? this.inValidation : this.inValidation && this.inValidation.postcode;
      },
      countryValidation: function () {
        return this.valueType === 'string' ? this.inValidation : this.inValidation && this.inValidation.country_id;
      },
      fullAddressValidation: function () {
        if (this.valueType === 'string') {
          return this.inValidation
        }
        return this.inValidation.line_1
          || this.inValidation.suburb
          || this.inValidation.state
          || this.inValidation.postcode
          || this.inValidation.country_id;
      },
    },
    watch: {
      address:{
        deep: true,
        handler: function(newVal, oldVal){
          this.pivotShowingAddress(newVal)
        }
      },
    },
    mounted() {
      this.getCountries();
      if (this.address.country && this.address.country.id) {
        this.address.country_id = this.address.country.id
      }
      if (this.showAddressType && this.address.types) {
        this.addressTypes = this.address.types.map((item) => {
          return {name: item.name}
        });

        this.address.types = this.address.types.map((item) => {
          return item.name
        })
      }
      this.pivotShowingAddress(this.address)
    },

    methods: {
      ...addressTypesMethods,
      ...countriesMethods,
      getStringFromObjectAddress,
      pivotShowingAddress(newVal){
        if (newVal){
          let addr
          if (this.valueType === 'string'){
            addr = this.value
          }
          addr = this.getStringFromObjectAddress(newVal, this.listCountries.data)
          if (addr){
            this.$set(this, 'showingAddress', addr)
          }
        }
      },
      toggleManualForm(isShow) {
        if(this.disabled){
          return
        }
        this.isShowManualForm = isShow;
      },
      getAddressData(addressData, placeResultData, id) {
        this.innited.address = true
        if (this.selfHandleAddress || this.valueType === 'string') {
          this.$set(this, 'address', this.parseDataAddressData(this.address, addressData, this.listCountries.data));
          if (this.valueType !== 'string') {
            this.$set(this, 'address', { ...this.address });
          }
        }
        this.onChangeAddressManually();
        this.$emit('changed', addressData, placeResultData, id)
      },
      selectAddressType(type) {
        this.address.types.push(type.name)
      },
      removeAddressType(type) {
        this.address.types = this.removeElement(this.address.types, type.name)
      },
      removeElement(array, elem) {
        const index = array.indexOf(elem);
        if (index > -1) {
          array.splice(index, 1);
        }
        return array;
      },
      onChangeAddressManually() {
        if (this.valueType !== 'string' || !this.address) return;
        const fullAddress = this.getStringFromObjectAddress(this.address, this.listCountries.data);
        this.$set(this, 'showingAddress', fullAddress)
        this.$emit('input', fullAddress);
      },
      onChangeAddressCountry() {

        this.onChangeAddressManually();
      },
    }
  }
</script>

<template>
  <div>
    <input
      v-if="address"
      v-model="address.is_edit"
      type="hidden"
      class="form-control"
      placeholder=""/>
    <div class="group-block">
      <slot></slot>
      <div
        v-if="!isShowManualForm || disabled"
        :class="['form-group', { 'is-invalid': fullAddressValidation || (inlineValidation && innited.address && !(showingAddress && showingAddress.length > 0)) }, 'tw-mb-2']">
        <label>{{ label && `${label} - ` }}Address lookup</label>
        <BaseAutoCompleteAddress
          :id="id"
          :disabled="disabled"
          :value="showingAddress"
          show-add-manual
          @placechanged="getAddressData"
          @addManualSelected="toggleManualForm(true); innited.address = true"
          @changed="innited.address = true"
        />
        <div class="invalid-feedback">
          <span>{{ fullAddressValidation }} </span>
          <span
            v-if="valueType !== 'string'"
            :disabled="disabled"
            class="curs-p text-bold"
            @click="toggleManualForm(true)"
          >Click here to update.</span>
        </div>
        <p class="optional !tw-leading-4 md:!tw-leading-6">This field uses Google Maps to populate all the below address fields automatically. <br>
          For non-physical addresses you can <span :class="['optional !tw-leading-4 md:!tw-leading-6', { 'curs-p !tw-text-positive link text-bold': !disabled }]" @click="toggleManualForm(true)">add the address manually</span>
        </p>
      </div>

      <div v-else>
        <div class="form-group tw-mb-2">
          <label>{{ label && `${label} - ` }}Manual Address</label> <br/>
          <p class="optional !tw-leading-4 md:!tw-leading-6">Enter the address in the form below or <span class="optional !tw-leading-4 md:!tw-leading-6 curs-p !tw-text-positive link text-bold" @click="toggleManualForm(false)">revert to Google Maps Address Lookup</span></p>
        </div>
        <div :class="['form-group', 'fix-border-t-3', 'tw-pt-2', 'tw-mb-2', { 'is-invalid': addressValidation }]">
          <label>Address</label>
          <textarea
            v-model="address.line_1"
            :disabled="disabled"
            rows="10"
            class="form-control pd-t-12 mn-h-46"
            placeholder="E.g. Unit 217 Paper st"
            @change="onChangeAddressManually"
          >
          </textarea>
          <p class="optional !tw-leading-4 md:!tw-leading-6"> Use this field to enter the full address lines</p>
          <div class="invalid-feedback">{{ addressValidation }}</div>
        </div>

        <div :class="['form-group', 'tw-mb-3', { 'is-invalid': suburbValidation }]">
          <label>Suburb / Town</label>
          <input
            v-model="address.suburb"
            :disabled="disabled"
            type="text"
            class="form-control"
            @change="onChangeAddressManually"
          />
          <div class="invalid-feedback">{{ suburbValidation }}</div>
        </div>

        <section class="tw-inline-flex tw-flex-col md:tw-flex-row tw-gap-x-5 tw-w-full">
          <div
            class="form-group tw-mb-3 tw-w-full md:tw-w-1/2"
            :class="{
              'is-invalid': stateValidation,
            }">
            <label>State</label>
            <input
              v-model="address.state"
              :disabled="disabled"
              type="text"
              class="form-control"
              placeholder="E.g. Victoria"
              @change="onChangeAddressManually"
            />
            <div class="invalid-feedback">{{ stateValidation }}</div>
          </div>
          <div
            class="form-group tw-mb-3 tw-w-full md:tw-w-1/2"
            :class="{
              'is-invalid': postcodeValidation,
            }">
            <label>Postcode</label>
            <input
              v-model="address.postcode"
              :disabled="disabled"
              type="text"
              class="form-control"
              placeholder="E.g. 3000"
              @change="onChangeAddressManually"
            />
            <div class="invalid-feedback">{{ postcodeValidation }}</div>
          </div>
        </section>

        <div v-if="listCountries.data" :class="['form-group', 'tw-mb-3', { 'is-invalid': countryValidation }]">
          <label>Country</label>
          <Multiselect
            v-model="address.country"
            :class="{
              'scrollable': listCountries.data.length > 7,
            }"
            :options="listCountries.data"
            :disabled="disabled"
            label="name"
            track-by="id"
            class="bind-width"
            @change="onChangeAddressManually"
          />
          <div class="invalid-feedback">{{ countryValidation }}</div>
        </div>
      </div>

      <div v-if="showAddressType && listAddressTypes.data" :class="['form-group', { 'is-invalid': inValidation.types },  'tw-mb-2']">
        <label class="label-control">Address Type</label>
        <div class="tw-flex align-items-center justify-content-between group-has-switch">
          <Multiselect
            v-model="addressTypes"
            :multiple="true"
            :class="{
              'scrollable': listAddressTypes.data.length > 7,
            }"
            :options="listAddressTypes.data"
            :disabled="disabled"
            label="name"
            track-by="name"
            class="bind-width"
            @select="selectAddressType"
            @remove="removeAddressType"
          />
          <div class="switch-content pd-l-25">
            <label class="switch">
              <input
                v-model="address.is_primary"
                :disabled="disabled"
                type="checkbox"
                checked
                class="input-switch">
              <span class="slider"></span>
            </label>
            <span class="value">Primary</span>
          </div>
        </div>
        <div class="invalid-feedback">{{ inValidation.type }}</div>
      </div>

    </div>
  </div>
</template>
